import React from 'react';
export function JournalHeader() {
  return <header className="w-full border-b-4 border-[#2B4C7E] bg-[#F9F8F6] pt-8 pb-2 px-4 mb-8" data-id="element-276">
      <div className="max-w-5xl mx-auto text-center" data-id="element-277">
        <h1 className="text-4xl md:text-6xl font-bold text-[#1B1B2F] mb-2 tracking-tight" data-id="element-278">
          EvidentiaMed
        </h1>
        <p className="text-xs md:text-sm font-medium text-[#6B7280] tracking-[0.2em] uppercase mb-6" data-id="element-279">
          Gesundheitsforschung seit 1997
        </p>

        <div className="border-t border-[#D1D5DB] py-2 flex flex-col md:flex-row justify-between items-center text-xs font-semibold text-[#4B5563] uppercase tracking-wider" data-id="element-280">
          <span data-id="element-281">Bd. 47, Nr. 12</span>
          <span data-id="element-282">Dienstag, 11. Februar 2026</span>
          <span data-id="element-283">Werbung</span>
        </div>
      </div>
    </header>;
}